import type {
  EffectConfig,
  EffectParams,
  EffectPower,
  EffectTwoAxes,
  SchemaGroup,
} from '../types';
import {
  delay,
  durationMedium,
  power,
  directionFourSides as direction,
  easing,
} from './baseParams';

export interface Fold extends EffectParams {
  direction: EffectTwoAxes;
  power?: EffectPower;
  angle?: number;
}

const name = 'Fold';
const groups: SchemaGroup[] = ['ongoing', 'animation'];

export const config: EffectConfig<Fold> = {
  name,
  groups,
  schema: {
    delay: { ...delay },
    duration: { ...durationMedium, default: 3000 },
    direction: { ...direction, default: 'top' },
    power: { ...power },
  },
} as const;

export const responsiveConfig: EffectConfig<Fold> = {
  name,
  groups,
  schema: {
    delay: { ...delay },
    duration: { ...durationMedium, default: 3000 },
    direction: { ...direction, default: 'top' },
    easing: { ...easing, default: 'cubicInOut' },
    angle: {
      type: 'number',
      min: 5,
      max: 45,
      step: 5,
      default: 30,
    },
  },
} as const;
